// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iKY7ck7JTlEsToyK15XR{
    border: 1px solid #dcdce4;
    text-align: center;
    padding-top: 20px;
    padding-bottom: 20px;
}

.iKY7ck7JTlEsToyK15XR img{
    width: 100%;
}

.cWW0wLhzNxkznsyaAvf6 {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.vjPeZszxIq7F6VWMoPiE {
    width: fit-content;
}`, "",{"version":3,"sources":["webpack://./src/plugins/custom-fields/admin/src/components/WidenButton/WidenButton.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".iframe-container{\n    border: 1px solid #dcdce4;\n    text-align: center;\n    padding-top: 20px;\n    padding-bottom: 20px;\n}\n\n.iframe-container img{\n    width: 100%;\n}\n\n.actionContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.button {\n    width: fit-content;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iframe-container": `iKY7ck7JTlEsToyK15XR`,
	"actionContainer": `cWW0wLhzNxkznsyaAvf6`,
	"button": `vjPeZszxIq7F6VWMoPiE`
};
export default ___CSS_LOADER_EXPORT___;
